import React, { Component } from "react";
import PropTypes from "prop-types";
// import { Link } from 'react-router-dom';
// import DropdownButton from './DropdownButton';
import Button from "./Button";
import DropdownButton from "./DropdownButton";
import Icon from "./Icon";

export default class EmailWidthPicker extends Component {
  constructor(props) {
    super(props);
    this.setWidthDesktop = this.setWidthDesktop.bind(this);
    this.setWidthMobile = this.setWidthMobile.bind(this);
    this.setWidthManual = this.setWidthManual.bind(this);
  }

  setWidthDesktop() {
    this.props.onChange(600);
  }

  setWidthMobile() {
    this.props.onChange(300);
  }

  setWidthManual(e) {
    this.props.onChange(parseInt(e.currentTarget.value));
  }

  render() {
    const { width } = this.props;
    return (
      <span>
        <input
          type="number"
          min="250"
          max="1200"
          placeholder="Width"
          value={width}
          onChange={this.setWidthManual}
        />
        <label
          style={{
            display: "inline-block",
            marginLeft: 4,
            marginRight: 10,
            fontWeight: "normal",
          }}
        >
          px
        </label>

        <DropdownButton
          type="link"
          pin="right"
          options={[
            {
              label: "Desktop - 600px",
              onClick: this.props.onChange,
              data: 600,
            },
            {
              label: "Mobile - 300px",
              onClick: this.props.onChange,
              data: 300,
            },
            {
              type: "divider",
            },
            {
              label: "iPhone 5, SE - 320px",
              onClick: this.props.onChange,
              data: 320,
            },
            {
              label: "iPhone 6, 6s, 7, 8 - 375px",
              onClick: this.props.onChange,
              data: 375,
            },
            {
              label: "iPhone 6+, 6s+, 7+, 8+ - 414px",
              onClick: this.props.onChange,
              data: 414,
            },
            {
              label: "iPhone X - 375 px",
              onClick: this.props.onChange,
              data: 375,
            },
          ]}
        />
      </span>
    );
  }
}

EmailWidthPicker.propTypes = {
  // accountId: PropTypes.string.isRequired,
  // emailTemplate: PropTypes.object.isRequired,
  // onClone: PropTypes.func.isRequired,
  // onDelete: PropTypes.func.isRequired
};
